import { render, staticRenderFns } from "./SettingsRegistrationType.vue?vue&type=template&id=c845a16e&"
import script from "./SettingsRegistrationType.vue?vue&type=script&lang=js&"
export * from "./SettingsRegistrationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports